export const loanOfficer = {
  firstName: 'Jordan',
  fullName: 'Jordan Reyes',
  title: 'Senior Loan Officer',
  branch: 'Reach Home Loans · North Metro',
}
